import { render } from "./AddCustomer.vue?vue&type=template&id=0ae10c73&ts=true"
import script from "./AddCustomer.vue?vue&type=script&lang=ts"
export * from "./AddCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__